import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ProductAgreementDTO } from '@iota/iota-management-portal-v4-client';
import { IotaModalOptions, IotaModalSize, MatDialogRef } from '@iota/iota-ui-components';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs';
import { UpsertProductAgreement } from 'src/app/store/actions/agreement.actions';
import { agreementsActionLoading } from 'src/app/store/reducer/agreement.reducer';

@Component({
    standalone: false,
    selector: 'app-dialog-create-agreement',
    templateUrl: './dialog-create-agreement.component.html',
    styleUrls: ['./dialog-create-agreement.component.scss']
})
export class DialogCreateAgreementComponent {
    public modalOptions: Partial<IotaModalOptions> = {
        size: IotaModalSize.SIZE_3XL,
        showToggleFullScreenButton: true
    };

    form = new UntypedFormGroup({
        name: new UntypedFormControl(null, [Validators.required]),
        comment: new UntypedFormControl(null, [Validators.required]),
        versionFrom: new UntypedFormControl(new Date(), Validators.required),
        versionTo: new UntypedFormControl()
    });

    loading$ = this.store.select(agreementsActionLoading);

    constructor(
        public dialogRef: MatDialogRef<DialogCreateAgreementComponent>,
        private store: Store
    ) {}

    resetVersionTo(): void {
        this.form.controls.versionTo.reset();
    }

    onCancelClick(): void {
        this.dialogRef.close();
    }

    onSaveClick() {
        const { name, comment, versionFrom, versionTo } = this.form.getRawValue();
        const data = {
            name,
            comment,
            versionFrom,
            versionTo: versionTo ?? undefined
        } as ProductAgreementDTO;

        this.store.dispatch(UpsertProductAgreement({ agreement: data }));

        this.store
            .select(agreementsActionLoading)
            .pipe(
                filter((loading) => !loading),
                take(1)
            )
            .subscribe(() => {
                this.dialogRef.close();
            });
    }
}
